import { fn } from "@ember/helper";
import { on } from "@ember/modifier";
import { LinkTo } from "@ember/routing";
import { eq } from "discourse/truth-helpers";
import dIcon from "discourse/ui-kit/helpers/d-icon";

export default <template>
  <li class="community-secondary-navigation__item">
    {{#if (eq @item.kind "disclosure")}}
      <details class="community-secondary-navigation__disclosure" open>
        <summary
          class="community-secondary-navigation__link community-secondary-navigation__disclosure-summary"
        >
          <span>{{@item.label}}</span>
        </summary>
        <ul class="community-secondary-navigation__children">
          {{#each @item.children as |child|}}
            <li class="community-secondary-navigation__item">
              <a
                href={{child.href}}
                aria-current={{if (eq @activeItemKey child.key) "page"}}
                class="community-secondary-navigation__link
                  {{if (eq @activeItemKey child.key) '--active'}}"
                {{on "click" (fn @onNavigate child)}}
              >
                {{dIcon "folder"}}
                <span>{{child.label}}</span>
              </a>
            </li>
          {{/each}}
        </ul>
      </details>
    {{else if (eq @item.key "all_topics")}}
      <LinkTo
        @route={{@everythingLink.route}}
        @query={{@everythingLink.query}}
        @current-when={{@everythingLink.currentWhen}}
        class="community-secondary-navigation__link"
        {{on "click" @onClose}}
      >
        {{dIcon "layer-group"}}
        <span>{{@item.label}}</span>
        {{#if @everythingLink.badgeText}}
          <span
            class="community-secondary-navigation__badge"
          >{{@everythingLink.badgeText}}</span>
        {{/if}}
      </LinkTo>
    {{else}}
      <a
        href={{@item.href}}
        aria-current={{if (eq @activeItemKey @item.key) "page"}}
        class="community-secondary-navigation__link
          {{if (eq @activeItemKey @item.key) '--active'}}"
        {{on "click" (fn @onNavigate @item)}}
      >
        {{dIcon
          (if
            (eq @item.kind "channel")
            "comments"
            (if @item.placeholder "clock" "folder")
          )
        }}
        <span>{{@item.label}}</span>
      </a>
    {{/if}}
  </li>
</template>
